<template>
	<div class="pagenation lrge clearfix">
		<i class="icon-leftArrow prev"></i>
		<span class="on num">1</span>
		<i class="icon-omit last" v-if="currentPage>6"></i>
		<span class="num">2</span>
		<span class="num">3</span>
		<span class="num">4</span>
		<span class="num">5</span>
		<span class="num">6</span>
		<span class="num">7</span>
		<i class="icon-omit last"></i>
		<span class="num last">20</span>
		<i class="icon-rightArrow next"></i>
	</div>
</template>
<script>
	export default {
		name: 'Pagenation',
		props: {
			volume: {
				type: Number
			}
		},
		data() {
			return {
				currentPage: 1
			}
		}
	}
</script>
<style scoped lang="scss">

	@import '../../../docs/scss/variables';
	/*page-ctr*/
	/*start*/
	.pagenation,
	{
		display: inline-block;
		font-size: 12px;
		font-family: "Avenir", arial, sans-serif;
		line-height: 18px;
		float: right;
	}
	.pagenation span,
	.pagenation i.prev,
	.pagenation i.next,
	{
		width: 20px;
		height: 20px;

		position: relative;
		float: left;
		display: inline-block;
		box-sizing: border-box;

		font-weight: 600;
		text-align: center;

		border-radius: 50%;

		cursor: pointer;
		transition: all 0.15s;
	}
	.pagenation span,
	{
		line-height: inherit;
		border: 1px solid $gray;
	}
	.pagenation span:not(:nth-child(2)),
	{
		margin-left: 8px;
	}

	.pagenation span:hover,
	{
		border-color: $dark-gray;
		color: $dark-gray;
		z-index: 10;
	}

	.pagenation span.on,
	.pagenation i.prev:hover, 
	.pagenation i.next:hover {
		color: #fff;
		background: $dark-gray;
		border: 1px solid $dark-gray;
		z-index: 10;
	}
	.pagenation i.prev, 
	.pagenation i.next {
		line-height: inherit;
		color: $dark-gray;
		border: 1px solid $dark-gray;	

	}

	.pagenation .prev:before, 
	.pagenation .next:before {
		font-size: 8px;
		display: inline-block;
		line-height: inherit;
		vertical-align: 2px;
	}
	.pagenation  i.next {
		margin-left: 15px;
	}
	.pagenation i.prev,
	.page-ctr-square i.prev,
	.page-ctr-txt i.prev {
		margin-right: 7px;
	}
	.pagenation i.icon-omit {
		margin-left: 8px;
		float: left;
		text-align: center;
	}
	.pagenation i.icon-omit:before {
		// font-size: 6px;
		transform: scale(0.5);
		display: inline-block;
		vertical-align: 2px;
		color: #a4a4ac;
		line-height: inherit;
	}

	.icon-rightArrow:before, .icon-leftArrow:before {
		transform: scale(0.8);
	}




	/*page-ctr*/
	/*end*/

</style>


// WEBPACK FOOTER //
// src/components/pagenation/Pagenation.vue